import { faCheck, faExclamationCircle, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { UserEnablePasswordRequestSchema } from "consumerhouse-shared";
import React, { useContext } from "react";
import { RouteComponentProps, useHistory } from "react-router";
import { AnyListener, useForm } from "typed-react-form";
import AuthContext from "../AuthContext";
import Button from "../components/Button";
import CenterContainer from "../components/CenterContainer";
import { Form, FormLabel, FormNote, FormRow, FormText } from "../components/FormElements";
import Title from "../components/Title";
import { useLanguage } from "../useLanguage";
import { ReactComponent as UndrawEnter } from "../data/undraw_enter.svg";
import { UndrawContainer } from "../components/UndrawContainer";
import Alert from "../components/Alert";

export function EnableAccount(props: RouteComponentProps<{ email: string }>) {
    const { client, auth, setAuth } = useContext(AuthContext);
    const form = useForm({ email: decodeURIComponent(props.match.params.email), password: "" }, (data) =>
        UserEnablePasswordRequestSchema.validate(data)
    );
    const language = useLanguage();
    const history = useHistory();
    if (auth) {
        history.push("/account");
        return null;
    }
    return (
        <CenterContainer width="500px" style={{ margin: "2em 0" }}>
            {window.innerWidth > 600 && (
                <UndrawContainer>
                    <UndrawEnter />
                </UndrawContainer>
            )}
            <Title>{language("register")}</Title>
            <Form
                onSubmit={async (ev) => {
                    ev.preventDefault();
                    if (!(await form.validate())) return;
                    form.setState({ isSubmitting: true });
                    let res = await client.fetch("/user/enablepassword", form.values);
                    if (res.status === "ok") {
                        setAuth({ accessToken: res.accessToken, refreshToken: res.refreshToken, user: res.user });
                    }
                    form.setState({ isSubmitting: false });
                }}>
                <Alert style={{ margin: "1em 0", flexWrap: "nowrap" }} color="#1111" textColor="black" icon={faQuestionCircle}>
                    {language("error-account-no-password")}
                </Alert>
                <FormRow>
                    <FormLabel>{language("register-email")}</FormLabel>
                    <FormText readOnly form={form} name="email" style={{ flexGrow: 1 }} />
                </FormRow>
                <FormRow>
                    <FormLabel>{language("register-password")}</FormLabel>
                    <FormText type="password" placeholder={language("login-secret")} form={form} name="password" />
                </FormRow>
                <hr />
                <AnyListener
                    form={form}
                    render={() => (
                        <Button type="submit" loading={form.state.isSubmitting} disabled={form.state.isSubmitting}>
                            {language("register")}
                        </Button>
                    )}
                />
            </Form>
        </CenterContainer>
    );
}
